import { Tooltip } from 'antd'
import classNames from 'classnames'
import React from 'react'
import './index.less'

export default ({ children, overlayClassName = null, ...otherProps }) => {
  return <Tooltip
    overlayClassName={classNames('mn-tooltip', overlayClassName)}
    {...otherProps}
  >
    {children}
  </Tooltip>
}
